module.exports = __webpack_public_path__ + "static/media/I9P-01.f30bdb25.svg";